import { useState } from 'react';

interface UseDocumentUploadProps<T> {
   
  onUpload: (files: File[], selectedOption: T | null) => Promise<void>;
   
  onError?: (error: unknown) => void;
  requiresSelection?: boolean;
}

interface UseDocumentUploadReturn<T> {
  isModalOpen: boolean;
  uploadedFiles: File[];
  selectedOption: T | null;
  openModal: () => void;
  closeModal: () => void;
   
  handleSelectOption: (value: T) => void;
  handleSubmit: () => Promise<void>;
  setUploadedFiles: React.Dispatch<React.SetStateAction<File[]>>;
}

const useDocumentUpload = <T,>({
  onUpload,
  onError,
  requiresSelection = false,
}: UseDocumentUploadProps<T>): UseDocumentUploadReturn<T> => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const [selectedOption, setSelectedOption] = useState<T | null>(null);

  const openModal = () => setIsModalOpen(true);

  const closeModal = () => setIsModalOpen(false);

  const handleSelectOption = (value: T) => setSelectedOption(value);

  const resetState = () => {
    setSelectedOption(null);
    setUploadedFiles([]);
  };

  const handleSubmit = async () => {
    if (requiresSelection && !selectedOption) {
      return;
    }

    try {
      await onUpload(uploadedFiles, selectedOption);
      resetState();
    } catch (error) {
      onError?.(error);
    }
  };

  return {
    isModalOpen,
    uploadedFiles,
    selectedOption,
    openModal,
    closeModal,
    handleSelectOption,
    handleSubmit,
    setUploadedFiles,
  };
};

export default useDocumentUpload;
